import React, { useContext } from "react";
import { AppContext } from "./AppContext";
import img from "../img/example.jpg";
import { useVenueStyle } from "../hooks/useVenueStyle";
import { accessibilityString } from "../utils/accessibility";

export const VenueCard: React.FC<{ venue: GeoJSON.Feature<any, any> }> = ({
  venue,
}) => {
  const { setSelectedVenue, tourVenues, addTourVenue, removeTourVenue } =
    useContext(AppContext);
  const venueStyle = useVenueStyle(venue);

  return (
    <div
      className="venue p-4 container-margin mb-4 md:mb-5 shadow dm-sans"
      style={venueStyle}
    >
      <div className="text-black mb-3">
        <div className="flex-1 mr-4">
          <div>
						<div className="heading-4">{venue.properties.title}{venue.properties.room_name && (
              <span> ({venue.properties.room_name})</span>
            )}</div>
            <div className="paragraph mt-1">{venue.properties.region}{venue.properties.ack_country && (
              <span>, {venue.properties.ack_country}</span>
            )}</div>
          </div>
          <div className="my-2 paragraph flex flex-wrap">
            <div className="flex flex-row mb-1 mr-3">
              <div className="w-5 mr-2" style={{ padding: "1px", marginTop: "-1px" }}>
                <svg viewBox="0 0 16.86 16.85" className="fill-black">
                  <path d="M16.82,8.24c-1.78-.97-3.62-1.84-5.41-2.78-.77-1.47-1.63-2.9-2.44-4.35-.17-.29-.29-.61-.46-.9-.19-.39-.31-.15-.44,.11-.36,.77-.78,1.52-1.14,2.3h0c-.42,.91-.89,1.79-1.28,2.71-.41,.12-.75,.39-1.13,.56-.61,.29-1.21,.58-1.8,.91-.89,.49-1.91,.85-2.71,1.45-.07,.13,.15,.19,.22,.25,.31,.21,.65,.44,.98,.61,1.38,.9,2.9,1.55,4.34,2.35,.32,.32,.41,.82,.64,1.21,.45,.86,.89,1.73,1.38,2.57,.21,.42,.43,.86,.65,1.26,.07,.09,.1,.31,.24,.27-.05,.13,.16,.14,.18,.03h0c.27-.53,.62-1.02,.91-1.54,.69-1.33,1.42-2.66,1.98-4.05,.72-.34,1.37-.81,2.06-1.19,1.04-.56,2.1-1.11,3.18-1.6,.09,.01,.13-.12,.06-.16Z" />
                </svg>
              </div>
              <div className="flex-1">
                {venue.properties.venue_type || "Other"}
              </div>
            </div>
            <div className="flex flex-row mb-1 mr-3">
              <div className="ml-1 w-4 mr-2">
                <svg viewBox="0 0 24 27" className="fill-black">
                  <path
                    d="M5.5,2.48a2.44,2.44,0,0,1-.42,1.38A2.52,2.52,0,0,1,4,4.78a2.52,2.52,0,0,1-2.73-.54A2.47,2.47,0,0,1,.68,1.53,2.49,2.49,0,0,1,1.6.42,2.58,2.58,0,0,1,3,0,2.51,2.51,0,0,1,4.77.73,2.44,2.44,0,0,1,5.5,2.48Z"
                    transform="translate(0 0)"
                  />
                  <path
                    d="M4.37,5.61H1.62A1.67,1.67,0,0,0,1,5.73a1.69,1.69,0,0,0-.53.35,1.54,1.54,0,0,0-.35.52A1.58,1.58,0,0,0,0,7.21v8a1.6,1.6,0,0,0,.34,1,1.7,1.7,0,0,0,.89.57L1.71,27H4.28l.36-10.24A1.61,1.61,0,0,0,6,15.18v-8a1.68,1.68,0,0,0-.13-.62,1.64,1.64,0,0,0-.35-.52A1.8,1.8,0,0,0,5,5.73a1.67,1.67,0,0,0-.62-.12Z"
                    transform="translate(0 0)"
                  />
                  <path
                    d="M14.51,2.48a2.42,2.42,0,0,1-.43,1.38,2.49,2.49,0,0,1-2.57,1.06,2.5,2.5,0,0,1-1.28-.68A2.52,2.52,0,0,1,9.54,3a2.53,2.53,0,0,1,.15-1.44A2.49,2.49,0,0,1,10.61.42a2.51,2.51,0,0,1,3.9,2.06"
                    transform="translate(0 0)"
                  />
                  <path
                    d="M13.38,5.61H10.63a1.62,1.62,0,0,0-1.15.47,1.54,1.54,0,0,0-.35.52A1.58,1.58,0,0,0,9,7.21v8a1.6,1.6,0,0,0,.34,1,1.64,1.64,0,0,0,.88.57L10.71,27h2.58l.36-10.24a1.63,1.63,0,0,0,1-.54,1.6,1.6,0,0,0,.39-1v-8a1.62,1.62,0,0,0-1.62-1.6Z"
                    transform="translate(0 0)"
                  />
                  <path
                    d="M23.51,2.48a2.52,2.52,0,0,1-.42,1.38A2.54,2.54,0,0,1,22,4.78a2.45,2.45,0,0,1-1.44.14,2.53,2.53,0,0,1-1.29-.68A2.44,2.44,0,0,1,18.55,3a2.46,2.46,0,0,1,.14-1.44A2.49,2.49,0,0,1,19.61.42,2.58,2.58,0,0,1,21,0a2.51,2.51,0,0,1,1.77.73A2.44,2.44,0,0,1,23.51,2.48Z"
                    transform="translate(0 0)"
                  />
                  <path d="M22.38,5.61H19.63a1.63,1.63,0,0,0-.62.12,1.58,1.58,0,0,0-.53.35,1.54,1.54,0,0,0-.35.52,1.58,1.58,0,0,0-.12.61v8a1.6,1.6,0,0,0,.34,1,1.66,1.66,0,0,0,.89.57L19.72,27h2.57l.36-10.24A1.59,1.59,0,0,0,24,15.18v-8a1.62,1.62,0,0,0-1.62-1.6Z" />
                </svg>
              </div>
              <div className="flex-1">{venue.properties.capacity_category}</div>
            </div>
            <div className="flex flex-row mr-3 mb-1">
              <div className="ml-1 w-4 mr-2">
                <svg viewBox="0 0 24 29" className="fill-black">
                  <path d="M5.73,15.25A5.78,5.78,0,0,0,4,17.1,5.74,5.74,0,0,0,3.6,22,5.78,5.78,0,0,0,5,24.09H5a5.87,5.87,0,0,0,2.5,1.46,5.85,5.85,0,0,0,5.48-1.22A5.68,5.68,0,0,0,14.56,22a.37.37,0,0,1,.18-.19.39.39,0,0,1,.26,0,.35.35,0,0,1,.18.16l1.53,2.62a.31.31,0,0,1,0,.19.3.3,0,0,1-.06.18,9.22,9.22,0,0,1-3.28,3,9.14,9.14,0,0,1-11-1.8,8.95,8.95,0,0,1-.94-11,9.08,9.08,0,0,1,4-3.33.32.32,0,0,1,.14,0,.3.3,0,0,1,.13,0,.41.41,0,0,1,.11.07.5.5,0,0,1,.08.12.28.28,0,0,1,0,.13V15a.35.35,0,0,1-.06.16.37.37,0,0,1-.12.13Zm5.74-9.86a3.25,3.25,0,0,1-2.25.91A3.2,3.2,0,0,1,7,5.37,3.14,3.14,0,0,1,7,.93a3.19,3.19,0,0,1,4.89.48,3.14,3.14,0,0,1,.54,1.75,3.18,3.18,0,0,1-.24,1.21A3.23,3.23,0,0,1,11.47,5.39Zm-.17,6.39v-3a1.4,1.4,0,0,0-.42-1h0a1.42,1.42,0,0,0-1-.42H8.33a1.54,1.54,0,0,0-1,.42h0a1.42,1.42,0,0,0-.42,1v9.49a1.19,1.19,0,0,0,.35.84,1.26,1.26,0,0,0,.85.36h7.07l3.47,6h0a1.21,1.21,0,0,0,1.64.43l3.54-2c.42-.24.4-2.28-2.89-1.18l-3.8-6.53A.27.27,0,0,0,17,16a.48.48,0,0,0-.17-.05H11.3v-1.8h5.1a1.19,1.19,0,0,0,0-2.38Z" />
                </svg>
              </div>
              <div className="flex-1">
                {accessibilityString(
                  venue.properties.accessibility_audience,
                  venue.properties.accessibility_artist
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
			<div className="flex">
				<div className="w-1/2 pr-2">
          <a
            target="_blank"
            href={venue.properties._path}
            rel="noreferrer"
            className="relative block w-full"
            style={venueStyle}
          >
						<div className="max-w-full w-full overflow-hidden relative venue-image-card">
							<img
								src={venue.properties.imageUrl || img}
								alt="Venue"
								className="max-w-full w-full mix-blend-multiply grayscale brightness-100 contrast-170 h-full absolute top-0 bottom-0 right-0 left-0 object-cover"
							/>
						</div>
          </a>
        </div>
				<div className="w-1/2 pl-2">
          <a
            target="_blank"
            href={venue.properties._path}
            rel="noreferrer"
            className="relative block w-full"
            style={venueStyle}
          >
					<button
							className="button-text button z-10 transition duration-300 text-black w-full border border-solid border-black mb-3"
							style={{ backgroundColor: "transparent" }}
						>
							More info
					</button>
          </a>
					<button
						className="flex-1 block button-text bg-black button w-full mb-3"
						onClick={() => setSelectedVenue(venue)}
					>
						Show on map{" "}
						<svg
							width="18px"
							className="inline-block -mt-1 ml-1"
							viewBox="0 0 18 10"
						>
							<path
								shapeRendering="geometricPrecision"
								d="M9,0C4,0,0,5,0,5s4,5,9,5,9-5,9-5S14,0,9,0ZM9,7.72A2.75,2.75,0,0,1,6.48,6,2.73,2.73,0,0,1,10,2.48,2.75,2.75,0,0,1,11.72,5,2.7,2.7,0,0,1,9,7.72Z"
							/>
						</svg>
					</button>
					<button
						className="flex-1 block button-text bg-black button w-full"
						onClick={() =>
							tourVenues.includes(venue)
								? removeTourVenue(venue)
								: addTourVenue(venue)
						}
					>
						{tourVenues.includes(venue) ? (
							<>
								Added{" "}
								<svg
									width="15px"
									className="inline-block -mt-1 ml-1"
									viewBox="0 0 14 14"
								>
									<path
										shapeRendering="geometricPrecision"
										d="M7,0a7,7,0,1,0,7,7A7,7,0,0,0,7,0ZM5.37,11.23,2,7.82,3.57,6.21,5.39,8l4.81-4.8,1.59,1.6Z"
									/>
								</svg>
							</>
						) : (
							<>
								Add to route{" "}
								<svg
									width="15px"
									className="inline-block -mt-1 ml-1"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 14 14"
								>
									<path
										shapeRendering="geometricPrecision"
										d="M7,0a7,7,0,1,0,7,7A7,7,0,0,0,7,0Zm4.53,8.17H8.17v3.36H5.83V8.17H2.46V5.83H5.83V2.46H8.17V5.83h3.36Z"
									/>
								</svg>
							</>
						)}
					</button>
				</div>
			</div>
    </div>
  );
};
